/**
 * UI constants
 */
export const ACTIVITY_LOG_MAX_EVENTS = 50;
export const NOTIFICATIONS_MAX_COUNT = 50;
